/*
 * @ Author: wangjiyu
 * @Date: 2019-11-13 11:13:03
 * @LastEditTime: 2019-11-13 13:25:45
 * @LastEditors: wangjiyu
 * @Description: file content
 */
const res: { [index: string]: { icon: string } } = {
    '[哈哈]': { icon: '001.png' },
    '[嘻嘻]': { icon: '002.png' },
    '[哭笑不得]': { icon: '003.png' },
    '[奸笑]': { icon: '004.png' },
    '[调皮]': { icon: '005.png' },
    '[囧]': { icon: '006.png' },
    '[捂脸]': { icon: '007.png' },
    '[发呆]': { icon: '008.png' },
    '[闭嘴]': { icon: '009.png' },
    '[酷]': { icon: '010.png' },
    '[大哭]': { icon: '011.png' },
    '[伤心]': { icon: '012.png' },
    '[发怒]': { icon: '013.png' },
    '[无辜]': { icon: '014.png' },
    '[尴尬]': { icon: '015.png' },
    '[无语]': { icon: '016.png' },
    '[惊讶]': { icon: '017.png' },
    '[失望]': { icon: '018.png' },
    '[喜欢]': { icon: '019.png' },
    '[坏笑]': { icon: '020.png' },
    '[汗]': { icon: '021.png' },
    '[亲亲]': { icon: '022.png' },
    '[可怜]': { icon: '023.png' },
    '[阴险]': { icon: '024.png' },
    '[头晕目眩]': { icon: '025.png' },
    '[害羞]': { icon: '026.png' },
    '[大笑]': { icon: '027.png' },
    '[疑问]': { icon: '028.png' },
    '[可爱]': { icon: '029.png' },
    '[阴笑]': { icon: '030.png' },
    '[惊喜]': { icon: '031.png' },
    '[思考]': { icon: '032.png' },
    '[委屈]': { icon: '033.png' },
    '[皱眉]': { icon: '034.png' },
    '[鼓掌]': { icon: '035.png' },
    '[花]': { icon: '036.png' },
    '[心]': { icon: '037.png' },
    '[强]': { icon: '038.png' },
    '[弱]': { icon: '039.png' },
    '[便便]': { icon: '040.png' },
    '[不说]': { icon: '041.png' },
    '[呆]': { icon: '042.png' },
    '[衰]': { icon: '043.png' },
    '[哼]': { icon: '044.png' },
    '[难受]': { icon: '045.png' },
    '[害怕]': { icon: '046.png' },
    '[恐惧]': { icon: '047.png' },
    '[困倦]': { icon: '048.png' },
    '[恶魔]': { icon: '049.png' },
    '[外星人]': { icon: '050.png' },
    '[枯萎]': { icon: '051.png' },
    '[心碎]': { icon: '052.png' },
    '[猪]': { icon: '053.png' },
    '[西瓜]': { icon: '054.png' },
    '[咖啡]': { icon: '055.png' },
    '[红酒]': { icon: '056.png' },
    '[生日]': { icon: '057.png' }
};
export default res;
